export const ZODIAC_SIGNS = [
  { rashi: 'Mesha', sign: 'Aries', dates: 'Mar 21 - Apr 19' },
  { rashi: 'Vrishabha', sign: 'Taurus', dates: 'Apr 20 - May 20' },
  { rashi: 'Mithuna', sign: 'Gemini', dates: 'May 21 - Jun 20' },
  { rashi: 'Karka', sign: 'Cancer', dates: 'Jun 21 - Jul 22' },
  { rashi: 'Simha', sign: 'Leo', dates: 'Jul 23 - Aug 22' },
  { rashi: 'Kanya', sign: 'Virgo', dates: 'Aug 23 - Sep 22' },
  { rashi: 'Tula', sign: 'Libra', dates: 'Sep 23 - Oct 22' },
  { rashi: 'Vrishchika', sign: 'Scorpio', dates: 'Oct 23 - Nov 21' },
  { rashi: 'Dhanu', sign: 'Sagittarius', dates: 'Nov 22 - Dec 21' },
  { rashi: 'Makara', sign: 'Capricorn', dates: 'Dec 22 - Jan 19' },
  { rashi: 'Kumbha', sign: 'Aquarius', dates: 'Jan 20 - Feb 18' },
  { rashi: 'Meena', sign: 'Pisces', dates: 'Feb 19 - Mar 20' },
]
